import { render, staticRenderFns } from "./gidselect.vue?vue&type=template&id=6e0d3342&scoped=true"
import script from "./gidselect.vue?vue&type=script&lang=js"
export * from "./gidselect.vue?vue&type=script&lang=js"
import style0 from "./gidselect.vue?vue&type=style&index=0&id=6e0d3342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d3342",
  null
  
)

export default component.exports